<template>
<div class="card" v-bind:class="{'active' : current == id,'unavailable' : draft == true}"  v-on:click="(event)=>{
  this.$emit('selectCurrent',id,draft)}">
  <div class="h-sep v-center gap">
    <div class="vignette" v-bind:style="{ 'background-image': 'url(' + vignettePath + ')' }">

    </div>

    <div class="box-fill v-sep v-center">
      <h4 class="title">{{title}}</h4>
      <p class="description">{{description}}</p>
    </div>


    <div v-bind:class="{spin:loading && current == id,}" class="icon"></div>

  </div>

</div>
</template>

<script>
export default {
  name: 'card',
  props: {
    id: Number,
    title: String,
    draft: Boolean,
    description: String,
    vignettePath: String,
    current: Number,
    loading: Boolean
  }
}
</script>

<style scoped>

.spin{
  animation: spin 0.2s infinite linear;

}

@keyframes spin {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}


.card.unavailable{
  opacity: 0.4;
}

.card:not(.active){

}

.card.active {
background-size: 100% 100%;
}

.card {

  cursor:pointer;
  transition: all 0.2s;
  background-repeat: no-repeat;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0) 50%);
  background-size: 0% 100%;

  padding: 0.8rem 1.2rem;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.3);
}


.title {
  font-weight: 600;
  font-size: 0.8rem;
  margin: 0;
  margin-bottom: 0.4rem;
  text-transform: uppercase;
}

.description{
  margin: 0;
}

.vignette {
  min-width: 48px;
  min-height: 48px;
  max-width: 48px;
  max-height: 48px;
  background-color: lightgray;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  transition: all 0.1s;
}

.icon {
  width: 12px;
  height: 12px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('../assets/play_icon.svg');
  opacity: 1;

}

.card:not(.active) .icon {
  opacity: 0.4;
  background-image: url('../assets/pause_icon.svg');

}

.icon.spin{
  background-image: url('../assets/reload_arrow.svg');

}
.card:not(.unavailable).active:hover .icon {
  background-image: url('../assets/reload_arrow.svg');
}

.card:not(.active) .vignette {
  transform: scale(0.6);
}

.card.active .vignette{
  transform: scale(1);
}

.card:not(.unavailable):not(.active):hover .vignette {
  transform: scale(0.8);
}
</style>
